import { i18n } from "@/i18n"
import en from "@/i18n/locales/en/overview.json"
import fr from "@/i18n/locales/fr/overview.json"

/**
 * The `overview` namespace, in its own chunk that index.html preloads beside
 * the overview screen (vite.config.ts): the signed-in landing must not wait
 * for a second round trip. As `features/auth/i18n.ts`, it waits for i18next
 * when the route table loads first.
 */
export async function registerOverviewNamespace(): Promise<void> {
  if (!i18n.isInitialized) {
    await new Promise<void>((resolve) => {
      i18n.on("initialized", () => {
        resolve()
      })
    })
  }
  if (!i18n.hasResourceBundle("en", "overview")) i18n.addResourceBundle("en", "overview", en)
  if (!i18n.hasResourceBundle("fr", "overview")) i18n.addResourceBundle("fr", "overview", fr)
}
